<template>
  <div class="share-component">
    <textarea
      ref="copyUrlToClipBoard"
      class="share-component__copyUrlToClipBoard"
      type="text"
      aria-hidden="true"
      tabindex="-1"
    />
    <span class="share-component__heading">
      Dela med vänner
    </span>

    <button
      type="button"
      class="share-component__copy-link-to-clipboard share-component--circle-icon"
      :class="{'active': tooltip }"
      aria-label="Kopiera länk"
      @click="copyUrlToClipBoard"
    >
      <svgicon
        name="Communication/Link"
        class="share-component__icon share-component--copy-link"
      />
    </button>
    <social-sharing
      :title="title"
      :description="description"
      :quote="quote"
      :url="currentUrl"
      inline-template
      @open="trackSharing"
    >
      <div class="share-component__links-icon">
        <button
          type="button"
          aria-label="Dela på facebook"
          class="share-component__facebook share-component--circle-icon"
        >
          <network network="facebook">
            <svgicon
              name="Social/Facebook"
              class="share-component__icon share-component--facebook"
            />
          </network>
        </button>
        <button
          type="button"
          aria-label="Dela på twitter"
          class="share-component__twitter share-component--circle-icon"
        >
          <network network="twitter">
            <svgicon
              name="Social/Twitter"
              class="share-component__icon share-component--twitter"
            />
          </network>
        </button>
      </div>
    </social-sharing>
  </div>
</template>

<script>
import dataLayer from '@/analytics/dataLayer'
import '#/Social/Twitter'
import '#/Social/Facebook'
import '#/Communication/Link'

export default {
  name: "ShareComponent",
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    quote: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      tooltip: false,
      currentUrl: ''
    }
  },
  mounted () {
    this.currentUrl = window.location.href
  },
  methods: {
    copyUrlToClipBoard () {
      this.tooltip = true
      // copy url to clipboard
      let inputElement = this.$refs.copyUrlToClipBoard
      inputElement.value = window.location.href
      this.trackSharing('kopiera länk')

      if (inputElement.value) {
        inputElement.select()
        document.execCommand('copy')
      }
      setTimeout(() => {
        this.tooltip = false
      }, 1000)
    },
    trackSharing (method) {
      dataLayer.add({
        event: 'share',
        method: method
      })
    },
  }
}
</script>

<style lang="scss">
  .share-component {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    @include media-breakpoint-up(md) {
      display: inline-flex;
      justify-content: flex-end;
    }

    &__heading {
      @include font(text, 2, "light");

      margin-right: 0.5rem;
      margin-bottom: 0.0625rem;
      color: $color-grey-dark;
      display: inline-block;
    }

    &__copyUrlToClipBoard {
      width: 1%;
      opacity: 0;
      border: 0;
      position: absolute;
    }

    &__links-icon {
      display: inline-flex;
    }

    &__icon {
      fill: $color-secondary-cta-text;
      width: 1rem;
      height: 1rem;
      cursor: pointer;
    }

    &--circle-icon {
      width: 1.5rem;
      height: 1.5rem;
      background-color: $color-red-special;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 0;
      cursor: pointer;
      padding: 0;

      &:hover {
        background-color: $color-pink-light;

        .share-component__icon {
          fill: $color-white;
        }
      }

      &:first-child {
        margin-right: 0.5rem;
      }

      span {
        padding: 0.4375rem;
      }
    }

    &__copy-link-to-clipboard {
      border: 0;
      margin-right: 0.5rem;
      padding: 0;
      position: relative;

      &.active {
        &::before {
          content: '';
          position: absolute;
          z-index: 1;
          top: 2.1875rem;
          left: 0.8125rem;
          width: 0;
          height: 0;
          border-left: 0.3125rem solid transparent;
          border-right: 0.3125rem solid transparent;
          border-bottom: 0.3125rem solid rgba(0, 0, 0, 0.9);
          transition: all 1s ease;
        }

        &::after {
          content: 'Länk kopierad';
          position: absolute;
          z-index: 1;
          top: 2.5rem;
          left: -1.5625rem;
          width: 5.3125rem;
          height: 2rem;
          color: $color-white;
          padding: 0 0.5rem;

          @include font(text, 1, "normal");

          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          background: rgba(0, 0, 0, 0.9);
          border-radius: 0.25rem;
          transition: all  1s ease;
        }
      }
    }
  }
</style>
